import { PropertyReport } from 'types';

import { api } from './api';

interface GetPropertyReportsQueryParams {
  accountId: string;
  includeReportDetails?: boolean;
}

export const propertyReportApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPropertyReports: build.query<PropertyReport[], GetPropertyReportsQueryParams>({
      query: ({ accountId, includeReportDetails }) => ({
        url: `accounts/${accountId}/property-reports${includeReportDetails ? '?includeReportDetails=true' : ''}`,
      }),
      providesTags: () => [{ type: 'PropertyReports', id: 'LIST' }],
    }),
  }),
});

export const { useGetPropertyReportsQuery, useLazyGetPropertyReportsQuery } = propertyReportApi;
